import {
  IDataListTypes,
  IDataListMetadata,
  IDataList,
  ISortOrder,
  ISortBy,
} from './types';

export function saveDataListRequest(
  id: string | null,
  name: string,
  form_field_id: string,
  form_field_label: string,
  responsibleId: number,
  parent_id: string | null,
  active: boolean,
) {
  return {
    type: IDataListTypes.SAVE_DATA_LIST_REQUEST,
    payload: {
      id,
      name,
      form_field_id,
      form_field_label,
      active,
      parent_id,
      responsible: responsibleId,
    },
  };
}

export function saveDataListSuccess() {
  return {
    type: IDataListTypes.SAVE_DATA_LIST_SUCCESS,
  };
}

export function saveDataListFailure() {
  return {
    type: IDataListTypes.SAVE_DATA_LIST_FAILURE,
  };
}

export function listDataListRequest(
  search: string,
  page: number,
  limit: number,
  sortOrder: ISortOrder,
  sortBy: ISortBy,
) {
  return {
    type: IDataListTypes.LIST_DATA_LIST_REQUEST,
    payload: { search, sortOrder, sortBy, page, limit },
  };
}
export function listDataListSuccess(
  dataLists: IDataList[],
  total: number,
  sortOrder: ISortOrder,
  sortBy: ISortBy,
) {
  return {
    type: IDataListTypes.LIST_DATA_LIST_SUCCESS,
    payload: { sortOrder, sortBy, dataLists, total },
  };
}
export function listDataListFailure() {
  return {
    type: IDataListTypes.LIST_DATA_LIST_FAILURE,
  };
}

export function getDataListRequest(id: string) {
  return {
    type: IDataListTypes.GET_DATA_LIST_REQUEST,
    payload: { id },
  };
}

export function getDataListSuccess(dataList: IDataList) {
  return {
    type: IDataListTypes.GET_DATA_LIST_SUCCESS,
    payload: { dataList },
  };
}

export function getDataListFailure() {
  return {
    type: IDataListTypes.GET_DATA_LIST_FAILURE,
  };
}

export function getDataListMetadataRequest(
  { formFieldId, parentFormFieldValue }: any,
  search: string,
  page: number,
  limit: number,
) {
  return {
    type: IDataListTypes.GET_DATA_LIST_METADATA_REQUEST,
    payload: { formFieldId, parentFormFieldValue, search, page, limit },
  };
}
export function getDataListMetadataSuccess(
  total: number,
  metadata: IDataListMetadata[],
) {
  return {
    type: IDataListTypes.GET_DATA_LIST_METADATA_SUCCESS,
    payload: { total, metadata },
  };
}
export function getDataListMetadataFailure() {
  return {
    type: IDataListTypes.GET_DATA_LIST_METADATA_FAILURE,
  };
}

export function activateDataListRequest(data_list_id: string, active: boolean) {
  return {
    type: IDataListTypes.ACTIVATE_DATA_LIST_REQUEST,
    payload: { data_list_id, active },
  };
}
export function activateDataListSuccess(data_list_id: string, active: boolean) {
  return {
    type: IDataListTypes.ACTIVATE_DATA_LIST_SUCCESS,
    payload: { data_list_id, active },
  };
}
export function activateDataListFailure() {
  return {
    type: IDataListTypes.ACTIVATE_DATA_LIST_FAILURE,
  };
}
export function clearDataListRequest() {
  return {
    type: IDataListTypes.CLEAR_DATA_LIST_REQUEST,
  };
}

export function getMetadataTemplateDataListRequest() {
  return {
    type: IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_REQUEST,
  };
}
export function getMetadataTemplateDataListSuccess() {
  return {
    type: IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_SUCCESS,
  };
}
export function getMetadataTemplateDataListFailure() {
  return {
    type: IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_FAILURE,
  };
}

export function getMetadataFileDataListRequest(data_list_id: string) {
  return {
    type: IDataListTypes.GET_METADATA_FILE_DATA_LIST_REQUEST,
    payload: {
      data_list_id,
    },
  };
}
export function getMetadataFileDataListSuccess() {
  return {
    type: IDataListTypes.GET_METADATA_FILE_DATA_LIST_SUCCESS,
  };
}
export function getMetadataFileDataListFailure() {
  return {
    type: IDataListTypes.GET_METADATA_FILE_DATA_LIST_FAILURE,
  };
}

export function getMetadataFileByNameDataListRequest(filePath: string) {
  return {
    type: IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_REQUEST,
    payload: {
      filePath,
    },
  };
}
export function getMetadataFileByNameDataListSuccess() {
  return {
    type: IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_SUCCESS,
  };
}
export function getMetadataFileByNameDataListFailure() {
  return {
    type: IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_FAILURE,
  };
}
